<script>
export default {
  name: "hitchhikingCancel",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        cancelReason: "",
        content: ""
      },
      rules: {
        cancelReason: [
          { required: true, message: "请选择取消原因", trigger: "change" }
        ],
        content: [
          { required: true, message: "请输入取消原因", trigger: "blur" }
        ]
      },
      cancel: {
        1: '临时行程有变',
        2: '联系不上乘客',
        7: '其他'
      },
      show: false,
      loading: false
    }
  },
  methods: {
    cancelChange() {
      this.show = this.form.cancelReason === '其他'
    },
    actionFn() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const url = `/api/v1/manage/airport/cancel/${this.rowData.id}`;
          this.loading = true;
          const {code} = await this.$axios.post(url, {
            reason: this.form.cancelReason === '其他' ? this.form.content : this.form.cancelReason,
          });
          this.loading = false;
          if (code === 1) {
            this.$emit("handClose");
            this.$message.success("取消成功");
          }
        } else {
          return false;
        }
      });
    },
  }
}
</script>

<template>
  <div class="hitchhikingCancel">
    <el-form :model="form" :rules="rules" ref="form" label-width="80px">
      <el-form-item label="取消原因" prop="cancelReason">
        <el-select @change="cancelChange" v-model="form.cancelReason" placeholder="请选择">
          <el-option
              v-for="item in cancel"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="填写原因" prop="content" v-if="show">
        <el-input
            type="textarea"
            :rows="2"
            :maxlength="50"
            show-word-limit
            placeholder="请输入内容"
            v-model="form.content">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <div class="flex-end">
          <el-button type="primary" @click="actionFn" :loading="loading"
          >确定
          </el-button>
          <el-button @click="$emit('handClose')">取消</el-button>
        </div>
      </el-form-item>

    </el-form>
  </div>
</template>

<style scoped lang="less">

</style>